import $ from 'jquery'
import template from 'lodash.template'
import AjaxList from '../../components/ajaxList'
import toastr from '../../utils/toastr'
import { format } from '../../utils/currency'
import { localeDate } from '../../utils/date'

class Module {
  constructor ($module) {
    this.$container = $module.find('.js-referrals-container')
    this.$list = $module.find('.js-referrals_wrap')
    this.$url = $module.find('.js-referrals-url')
    this.$copyBtn = $module.find('.js-referrals-copy')
    this.template = template($module.find('.js-referral-template').html())

    this.list = new AjaxList({
      $container: this.$container,
      $form: $module.find('.js-referral-filter-form'),
      $load: $module.find('.js-referrals-load'),
      $sorting: $module.find('.js-dropdown-custom'),
      prefix: 'referral_list',
      append: (response, replace) => {
        this.append(response, replace)
      }
    })

    this.bind()
  }

  bind () {
    this.$copyBtn.click((e) => {
      e.preventDefault()
      this.copyUrl()
    })
  }

  copyUrl () {
    this.$url.select()

    try {
      document.execCommand('copy')
      toastr.success(this.$copyBtn.data('success'))
    } catch (err) {
    }
  }

  append (response, replace) {
    if (replace) {
      this.$list.empty()
    }

    if (!response.referrals.length) {
      this.$container.addClass('empty_list')
    } else {
      this.$container.removeClass('empty_list')

      let content = ''

      response.referrals.forEach((v) => {
        content += this.render(v)
      })

      this.$list.append(content)
    }
  }

  render (value) {
    return this.template({
      email: value.email,
      date: localeDate(value.create_date, {}),
      amount: format(value.referrer_award, 'rub')
    })
  }
}

$(function () {
  $('.js-referrals-list').each(function () {
    new Module($(this))
  })
})
